
import { QuestionMarkCircleIcon, MagnifyingGlassIcon, UserGroupIcon, SparklesIcon } from '@heroicons/react/24/outline';

const FAQHero = () => {
  return (
    <section className="bg-gradient-to-b from-primary/10 to-background py-16">
      <div className="container mx-auto px-4 text-center">
        <div className="flex items-center justify-center mb-6">
          <QuestionMarkCircleIcon className="h-12 w-12 text-primary mr-4" />
          <h1 className="text-5xl font-bold text-foreground">
            Frequently Asked <span className="text-primary">Questions</span>
          </h1>
        </div>
        
        <p className="text-xl text-muted-foreground mb-12 max-w-3xl mx-auto">
          Get instant answers to the most common questions about SeniorThrive features, 
          safety tools, family coordination, and getting started with thriving at home.
        </p>
        
        <div className="grid md:grid-cols-3 gap-6 max-w-3xl mx-auto">
          <div className="bg-card border rounded-lg p-6">
            <MagnifyingGlassIcon className="h-8 w-8 text-primary mx-auto mb-4" />
            <h3 className="font-semibold text-foreground mb-2">Smart Search</h3>
            <p className="text-sm text-muted-foreground">Find answers quickly with intelligent search</p>
          </div>
          <div className="bg-card border rounded-lg p-6">
            <UserGroupIcon className="h-8 w-8 text-primary mx-auto mb-4" />
            <h3 className="font-semibold text-foreground mb-2">Role-Based Help</h3>
            <p className="text-sm text-muted-foreground">Answers tailored to your specific needs</p>
          </div>
          <div className="bg-card border rounded-lg p-6">
            <SparklesIcon className="h-8 w-8 text-primary mx-auto mb-4" />
            <h3 className="font-semibold text-foreground mb-2">Always Updated</h3>
            <p className="text-sm text-muted-foreground">Fresh answers as we add new features</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQHero;
